var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseError',{attrs:{"httpCode":_vm.httpCode,"message":_vm.message,"toRoute":_vm.toRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }